var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: { id: "go-modal-login-move" },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-access" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCloseModal()
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-block-header" }, [
                    !_vm.isDeleteSuccess
                      ? _c("div", { staticClass: "go-msg-icon" }, [
                          _c("p", {
                            staticClass: "go-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "scrap-agent.delete-modal.process-title",
                                  { channelName: _vm.itemDelete.channelNameEn }
                                )
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDeleteSuccess
                      ? _c("div", { staticClass: "go-msg-icon" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "go-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("scrap-agent.delete-modal.success-title")
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-block-body" }, [
                    !_vm.isDeleteSuccess
                      ? _c("p", { staticClass: "go-channel-msg" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "scrap-agent.delete-modal.process-warning"
                                  )
                                ) +
                                "\n              "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDeleteSuccess
                      ? _c("span", { staticClass: "go-text-sub" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("scrap-agent.delete-modal.success-warning")
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  !_vm.isDeleteSuccess
                    ? _c("div", { staticClass: "go-block-between" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCloseModal()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("scrap-agent.cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAccessDelete()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("scrap-agent.delete")))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDeleteSuccess
                    ? _c("div", { staticClass: "go-block-between" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCloseAndLoading()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("scrap-agent.modal_close")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap complete" }, [
      _c("i", { staticClass: "go-icon-54 go-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("em", [
      _c("i", { staticClass: "go-icon-20 go-icon-alert-circle-filled" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }